export var ThreatHuntingStatus;
(function (ThreatHuntingStatus) {
    ThreatHuntingStatus["THREAT_HUNTING_STATUS_UNKNOWN"] = "THREAT_HUNTING_STATUS_UNKNOWN";
    ThreatHuntingStatus["THREAT_HUNTING_STATUS_REQUESTED"] = "THREAT_HUNTING_STATUS_REQUESTED";
    ThreatHuntingStatus["THREAT_HUNTING_STATUS_RUNNING"] = "THREAT_HUNTING_STATUS_RUNNING";
    ThreatHuntingStatus["THREAT_HUNTING_STATUS_COMPLETED"] = "THREAT_HUNTING_STATUS_COMPLETED";
    ThreatHuntingStatus["THREAT_HUNTING_STATUS_FAILED"] = "THREAT_HUNTING_STATUS_FAILED";
})(ThreatHuntingStatus || (ThreatHuntingStatus = {}));
